import axios from "axios";

export default class UserService {
    static async getAllUsers() {
        return await axios.get("/api/users/all");
    }
}